module.exports = __webpack_public_path__ + "img/9-siivilla.652cb552.jpg";